<div class="painel-principal" style="padding: 10px;">
    <div class="painel-consultar">
        <form #formConsultar="ngForm">
            <div fxLayout="column" fxLayoutAlign="space-around stretch" fxFlexFill>

                <div fxLayout="row" fxLayoutGap="50px" style="margin-top: 10px; margin-bottom: 10px" fxFlexFill>
                    <div ngModelGroup="comboTurmaPlanejamentoOficina" fxFlex="97%">
                        <combo-turma [showDisplayId]="false"
                                        [obrigatorio]="true"
                                        [selecionado]="comboTurmaSelecionado"
                                        (valorChange)="onValorChangeMaterial($event)"
                                        [label]="'Selecione uma turma'">
                        </combo-turma>
                    </div>
                </div>

            </div>
        </form>
    </div>
</div>

<div dir="rtl"  fxLayout="row" fxLayoutAlign="center center"
    fxLayoutGap="20px" style="padding-top: 20px; padding-bottom: 10px; padding-right: 20px" fxFlexFill>


    <button *ngIf="isAtualizar" mat-raised-button name="botaoLimpar" fxFlex="20%" color="primary"
        (click)="zerarCombos()">
        Limpar Turma
    </button>

    <button *ngIf="!isAtualizar" mat-raised-button name="botaoAdicionar" fxFlex="20%" color="primary"
        [disabled]=formConsultar.invalid (click)="adicionar()">
        Adicionar Turma
    </button>

    <button *ngIf="isAtualizar" mat-raised-button name="botaoLimpar" fxFlex="20%" color="primary" (click)="atualizar()">
        Atualizar Turma
    </button>

</div>
